import { EpicH1Span } from "@constellation-academy/epic-ui";
import { useState } from "react";
import { useLazyLoadQuery } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { offerCatalogue_Query } from "@relay/offerCatalogue_Query.graphql";
import { QUERY } from "./offer-catalogue.graphql";
import { headerWrapperClass } from "./offer-catalogue.styles";
import { OfferCatalogueTable } from "./parts/offer-catalogue-table";
import { BaseScreen } from "../../components/base-screen";

export const OfferCatalogueScreen = () => {
	const { t } = useTranslation("common");
	const [fetchKey, setFetchKey] = useState(0);

	const query = useLazyLoadQuery<offerCatalogue_Query>(
		QUERY,
		{ first: 50, tagIds: [] },
		{ fetchPolicy: "network-only", fetchKey },
	);

	const offers = (query.Admin.Offer.subscribableOffers.edges ?? [])
		.filter((e): e is NonNullable<typeof e> => e != null)
		.map((e) => e.node);

	return (
		<BaseScreen>
			<div className={headerWrapperClass}>
				<EpicH1Span>{t("offerCatalogue.title")}</EpicH1Span>
			</div>
			<OfferCatalogueTable offers={offers} onSubscribed={() => setFetchKey((k) => k + 1)} />
		</BaseScreen>
	);
};
